import { render, staticRenderFns } from "./live-nav.vue?vue&type=template&id=339e3b53&scoped=true"
import script from "./live-nav.vue?vue&type=script&lang=js"
export * from "./live-nav.vue?vue&type=script&lang=js"
import style0 from "./live-nav.vue?vue&type=style&index=0&id=339e3b53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339e3b53",
  null
  
)

export default component.exports